import style from "../CSS/RoundVideoResult.module.css";
import { useEffect, useState } from "react";

const Banner = ({ title, coverPhoto }) => {

  return (
    <>
      <div
        className={style.banner}
        style={{
          backgroundImage: `url(${coverPhoto})`,
        }}
      >
        <div className={style.banner__overlay}>
          <h4>{title}</h4>
        </div>
      </div>
    </>
  );
};

export default Banner;
